<template>
  <div class="container mt-5">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <div class="mb-3">
        <label class="form-label">Username</label>
        <input v-model="username" type="text" class="form-control" required />
      </div>
      <div class="mb-3">
        <label class="form-label">Password</label>
        <input v-model="password" type="password" class="form-control" required />
      </div>
      <button type="submit" class="btn btn-primary">Login</button>
    </form>
    <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
  </div>
</template>

<script>
import api from '../api/axios'

export default {
  data() {
    return {
      username: '',
      password: '',
      error: null
    }
  },
  mounted() {
    const token = localStorage.getItem('access_token')
    if (token) {
      this.$router.push('/')
    }
  },
  created() {
    this.error = null
  },
  methods: {
    async login() {
      try {
        const response = await api.post('/auth/login/', {
          username: this.username,
          password: this.password
        })
        localStorage.setItem('access_token', response.data.access)
        localStorage.setItem('refresh_token', response.data.refresh)
        
        // Fetch and store user profile details
        const { data: user } = await api.get('/users/me/')
        localStorage.setItem('username', user.username)
        localStorage.setItem('user_role', user.role || 'User')
        localStorage.setItem('user_email', user.email)
        
        this.$router.push('/')
      } catch (err) {
        this.error = 'Invalid username or password'
      }
    }
  }
}
</script>
